<ng-container *ngIf="open">
  <dialog
    #identityDialog
    class="identity-modal-panel"
    [attr.aria-labelledby]="titleId"
    [attr.aria-describedby]="descriptionId"
    (cancel)="onDialogCancel($event)"
  >
    <button
      *ngIf="closable"
      type="button"
      class="identity-modal-close"
      aria-label="Cerrar modal"
      title="Cerrar"
      (click)="close($event)"
    >
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="identity-modal-content">
      <section class="identity-modal-video" aria-label="Video de validación facial">
        <iframe
          *ngIf="safeYoutubeEmbedUrl; else videoUnavailableTpl"
          class="identity-modal-video-frame"
          [src]="safeYoutubeEmbedUrl"
          [attr.title]="videoTitle"
          loading="eager"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>

        <ng-template #videoUnavailableTpl>
          <div class="identity-modal-video-fallback">
            Video de validación no disponible
          </div>
        </ng-template>
      </section>

      <h2 [id]="titleId" class="identity-modal-title">
        {{ title }}
      </h2>

      <section [id]="descriptionId" class="identity-modal-steps" aria-label="Pasos para validar identidad">
        <article
          class="identity-modal-step"
          *ngFor="let step of validationSteps; trackBy: trackByStepId"
        >
          <span class="identity-modal-step-number" [class.identity-modal-step-number--active]="step.active">
            {{ step.id }}
          </span>

          <div class="identity-modal-step-copy">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </article>
      </section>

      <footer class="identity-modal-footer">
        <div class="identity-modal-download-copy">
          <span class="identity-modal-phone-icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.6905 8.66508V23.3351C27.6905 29.2031 26.2293 30.6701 20.3843 30.6701H11.6168C5.7718 30.6701 4.31055 29.2031 4.31055 23.3351V8.66508C4.31055 2.79708 5.7718 1.33008 11.6168 1.33008H20.3843C26.2293 1.33008 27.6905 2.79708 27.6905 8.66508Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.9231 6.46484H13.0781" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.0013 26.4149C17.2522 26.4149 18.2662 25.3968 18.2662 24.141C18.2662 22.8852 17.2522 21.8672 16.0013 21.8672C14.7504 21.8672 13.7363 22.8852 13.7363 24.141C13.7363 25.3968 14.7504 26.4149 16.0013 26.4149Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>

          <p>
            <strong>{{ downloadTitle }}</strong>
            <span>{{ footerText }}</span>
          </p>
        </div>

        <div class="identity-modal-actions" aria-label="Descarga la App Inclub">
          <a
            class="identity-modal-store"
            [href]="appStoreUrl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Descargar App Inclub en App Store"
          >
            <img
              class="identity-modal-store-badge identity-modal-store-badge--apple"
              [src]="appStoreBadgeUrl"
              alt=""
              loading="eager"
            />
          </a>

          <a
            class="identity-modal-store"
            [href]="playStoreUrl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Descargar App Inclub en Google Play"
          >
            <img
              class="identity-modal-store-badge identity-modal-store-badge--google"
              [src]="playStoreBadgeUrl"
              alt=""
              loading="eager"
            />
          </a>
        </div>
      </footer>

      <div *ngIf="!closable" class="identity-modal-session-actions">
        <button type="button" class="identity-modal-payment" (click)="requestPayment()">
          Pagar cuota
        </button>

        <button type="button" class="identity-modal-navigation" (click)="requestNetwork()">
          Red
        </button>

        <button
          type="button"
          class="identity-modal-logout"
          (click)="requestLogout()"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  </dialog>
</ng-container>
